import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getEnvironments = async (appId?: any) => {
  const { data } = await IBModuleApi.get(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/environment${
      appId ? `?appId=${appId}` : ""
    }`
  );

  return data;
};

export const createEnvironments = async (createInfo: any) => {
  const { data } = await IBModuleApi.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/environment`,
    createInfo
  );

  return data;
};

export const updateEnvironments = async (updateInfo: any) => {
  const { data } = await IBModuleApi.put(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/environment`,
    updateInfo
  );

  return data;
};

export const deleteEnvironment = async (envId: number) => {
  const { data } = await IBModuleApi.delete(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/environment/${envId}`
  );

  return data;
};


export const importEnvironment = async (importInfo: any) => {
  const { data } = await IBModuleApi.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/environment/import`,
    importInfo
  );

  return data;
};

export const getExportInfo = async (envId: string) => {
  const { data } = await IBModuleApi.get(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/environment/exportinfo?envId=${envId}`
  );

  return data;
};

export const exportEnvironment = async (info: any) => {
  const { envFullName, ...exportInfo } = info;
  const { data } = await IBModuleApi.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/environment/export`,
    { envFullName, ...exportInfo },
    {
      responseType: "blob",
    }
  );

  const href = URL.createObjectURL(data);
  const link = document.createElement("a");
  link.href = href;
  link.setAttribute("download", `${envFullName}.json`);
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};

export const deleteCacheApplication = async (envId: number) => {
  const { data } = await IBModuleApi.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/clear-cache`,
    {
      environmentId: envId,
    }
  );

  return data;
};
